module.exports = __webpack_public_path__ + "img/horizontal_5_1_9016.670806a1.png";